import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppinfoService } from 'app/services/appinfo.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { DomainService, GivColumnDomain } from 'app/services/domain.service';
import { AddressFishboneInfo } from 'app/services/fishbone.service';
import { ModelMenuItemKey } from 'app/services/main-data.service';
import { UserService } from 'app/services/user.service';

interface CellValueChange {
	colProp: string;
	val: any;
	type: 'input' | 'select'
}
interface CellColumn {
	prop: string;
	isUppercase?: boolean;
	neighborList?;
	// info?: {
	// 	neighborList?
	// }
}

export interface CountyNeighborOption {
	value: string;
	label: string;
}

@Component({
  selector: 'app-feat-edit-cell',
  templateUrl: './feat-edit-cell.component.html',
  styleUrls: ['./feat-edit-cell.component.css']
})
export class FeatEditCellComponent implements OnInit, OnChanges {

	@Input() cellValue: any;
	@Output() cellValueChange = new EventEmitter()


	@Input() domainsByColumn: {
		[colProp: string]: GivColumnDomain;
	} = {}
	@Input() column: CellColumn = {
		prop: null
	};
	@Input() cssClass: {
		[classString: string]: boolean
	} = {};
	@Input() inputPlaceholder?: string = '';
	@Input() isEditDisabled: boolean;
	@Input() standardColName?: string;
	@Input() modelKey: ModelMenuItemKey;

	@Output() blur: EventEmitter<any> = new EventEmitter();
	@Output() enter: EventEmitter<any> = new EventEmitter();
	@Output() valueChange: EventEmitter<CellValueChange> = new EventEmitter();

	isSpecialCol?: boolean;
	specialValue;

	colType

	stateColStandard: string;
	countyColStandard: string;
	stateLeftColStandard: string;
	stateRightColStandard: string;
	countyLeftColStandard: string;
	countyRightColStandard: string;
	stateOrCountyCols: string[];

	neighborOption = 'get_neighbor';

	constructor(
		private appinfoService: AppinfoService,
		private attrIndexService: AttrIndexService,
		private domainService: DomainService,
		private userService: UserService
	) { }

	onInputVal() {
		if (this.column.isUppercase) {
			if (this.cellValue && typeof this.cellValue === 'string') {
				this.cellValue = this.cellValue.toUpperCase();
			}
		}
		this.onChange('input');
	}
	onSelectVal() {
		this.onChange('select');
	}
	onBlur() {
		this.blur.emit();
	}
	onEnter() {
		this.enter.emit();
	}

	private onChange(type: 'input' | 'select') {
		this.cellValueChange.emit(this.cellValue);
		this.valueChange.emit({
			colProp: this.column.prop,
			val: this.cellValue,
			type: type
		});
	}

	onChangeStateOrCounty( newValue, selectEl?: HTMLSelectElement) {
		if (newValue === this.neighborOption) {
			// await this.domainService.getNagNeighbors(this.userService.customerInfo.givState, this.userService.customerInfo.cusCounties[0]);
			if (this.standardColName === this.stateColStandard || this.standardColName === this.stateLeftColStandard || this.standardColName === this.stateRightColStandard) {
				let neighbors: string[];
					// const states = this.userService.customerInfo.neighborCounties.map(i => i.split(' - ')[0]);
					// neighbors = states.filter((i, idx) => idx === states.indexOf(i));
				neighbors = this.userService.getStatesFromNeighborCounties();
				// neighbors = await this.domainService.getNagNeighbors(this.userService.customerInfo.givState);

				const domain = this.domainsByColumn[this.column.prop];
				if (domain.type === 'list') {
					neighbors = neighbors.filter(i => domain.list.indexOf(i) === -1);
				}
				this.column.neighborList = neighbors;
			} else if (this.standardColName === this.countyColStandard || this.standardColName === this.countyLeftColStandard || this.standardColName === this.countyRightColStandard) {
				let neighbors: CountyNeighborOption[] = this.userService.getNeighborCountiesFromCustomer();
				const domain = this.domainsByColumn[this.column.prop];
				if (domain.type === 'list') {
					neighbors = neighbors.filter(i => domain.list.indexOf(i.value) === -1);
				}
				this.column.neighborList = neighbors;
			}

			// selectEl.value = this.selectedRecord[col.prop];
			// setTimeout(() => {
			// 	selectEl.selectedIndex = neighbors.indexOf(this.cellValue);
			// });
		} else {
			this.cellValue = newValue;
			this.onSelectVal();
			// if (this.standardColName === this.countyColStandard) {
			// 	if (newValue && newValue.split(' - ').length > 1) {
			// 		this.cellValue = newValue.split(' - ')[1];
			// 	} else {
			// 		this.cellValue = newValue;
			// 	}
			// } else {
			// 	this.cellValue = newValue;
			// }
		}
	}
	private setFishboneDisplayVal() {
		let specialValue = '';
		const cellVal: AddressFishboneInfo = this.cellValue;
		if (this.modelKey !== 'L' && cellVal && cellVal.nena) {
			specialValue += cellVal.nena.cd;
		}
		if (this.modelKey === '') {
			specialValue += ' | ';
		}
		if (this.modelKey !== 'N' && cellVal && cellVal.legacy) {
			specialValue += cellVal.legacy.cd;
		}
		this.specialValue = specialValue;
	}
	ngOnInit() {
		this.stateColStandard = this.attrIndexService.stateColNameStandard;
		this.countyColStandard = this.attrIndexService.countyColNameStandard;
		this.stateLeftColStandard = this.attrIndexService.stateLeftColStandard;
		this.stateRightColStandard = this.attrIndexService.stateRightColStandard;
		this.countyLeftColStandard = this.attrIndexService.countyLeftColStandard;
		this.countyRightColStandard = this.attrIndexService.countyRightColStandard;
		this.stateOrCountyCols = [this.stateColStandard, this.stateLeftColStandard, this.stateRightColStandard, this.countyColStandard, this.countyLeftColStandard, this.countyRightColStandard];
		if (this.column && this.standardColName && (this.stateOrCountyCols.indexOf(this.standardColName) > -1)) {
			this.onChangeStateOrCounty(this.neighborOption);
		}
	}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.column) {
			const col = this.appinfoService.columnMap[this.column.prop];
			this.colType = col ? col.type : null;
			// Fishbone col
			this.isSpecialCol = this.column && this.column.prop === this.attrIndexService.addrFishboneCol;
			if (this.isSpecialCol) {
				this.setFishboneDisplayVal();
			}
		} else if (changes.modelKey || changes.cellValue) {
			if (this.isSpecialCol) {
				this.setFishboneDisplayVal();
			}
		}
	}

}
